import { mustNotBeBlankValidator } from '../../../../../common/utils';
import { Validators } from '@angular/forms';
import { PartnerExtIdType } from '../constants';
import { ControlStringProperty } from '../../../../../common/models';

export class PartnerExtIdsModel {
  id = '';
  type: PartnerExtIdType | string = '';
  constructor(params?: PartnerExtIdsModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PartnerExtIdsForm {
  constructor(
    extIdModel: PartnerExtIdsModel,
    hasUpdatePermission: boolean = true,
    public id: ControlStringProperty = [
      { value: extIdModel.id, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ],
    public type: ControlStringProperty = [
      { value: extIdModel.type, disabled: !hasUpdatePermission },
      [Validators.required],
    ],
  ) {}
}
